import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface VenueQuoteAssignmentResponse {
  data: {
    categories: {
      slug: string;
      name: string;
      item_type?: 'product' | 'variant_option' | 'mixed';
      products: {
        id: number;
        name: string;
        category: string;
        price: number;
        item_type?: 'product' | 'variant_option';
        product_id?: number;
        product_name?: string;
        variant_id?: number;
        variant_name?: string;
        option_category?: string | null;
      }[];
    }[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class VenueQuoteAssignmentService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAssignments(venueId: number): Observable<VenueQuoteAssignmentResponse> {
    return this.http.get<VenueQuoteAssignmentResponse>(`${this.apiUrl}/api/venues/${venueId}/quote-assignments`);
  }

  saveAssignments(
    venueId: number,
    categories: Record<string, { products: number[]; variant_options: number[] }>,
  ): Observable<VenueQuoteAssignmentResponse> {
    return this.http.post<VenueQuoteAssignmentResponse>(`${this.apiUrl}/api/venues/${venueId}/quote-assignments`, {
      categories,
    });
  }
}
